<template>
    <div>
        <div class="row ">
            <div class="col-md-10 col-md-offset-1">
                <h2>{{ $t(type + '.title') }}</h2>
                <p>
                    Dynamic ESS needs information about the energy prices of the grid to be able to
                    minimize the costs.
                </p>
            </div>
        </div>
        <div class="row">
            <div class="col-md-10 col-md-offset-1 choice-wrapper">
                <div class="choice" @click="() => choose('fixed')">
                    <div>Fixed {{ type }} prices</div>
                    <div>Choose this longer text lorem ipsum dolor sit amet</div>
                </div>
                <div class="choice" @click="() => choose('dynamic')">
                    <div>dynamic {{ type }} prices</div>
                    <div>Choose this longer text lorem ipsum dolor sit amet</div>
                </div>
            </div>
            <br />
            <!-- todo: add conditions here -->
            <div class="col-md-10 col-md-offset-1 vrm-info-box">
                <span class="vrm-card-icon sg-vrm-icon_012_alarm-32px"></span>
                <span>
                    Please make sure that this choice is for the buy prices. You will be able to
                    configure the sell prices later.
                </span>
            </div>
        </div>
    </div>
</template>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import VrmTextField from '@/vue/components/forms/VrmTextField.vue';

@Component({
    components: {
        VrmTextField,
    },
})
export default class Grid extends Vue {
    @Prop({ type: String })
    type;

    choose(type) {
        this.$emit('choose', type);
    }
}
</script>
